import { PatternInput } from './input/PatternInput';
import { StartUrlsInput } from './input/StartUrlsInput';
import { AIInput } from './input/AIInput';
import { ProxyInput } from './input/ProxyInput';
import { PriorityInput } from './input/PriorityInput';
import { TemplateInput } from './input/TemplateInput';
import { ExtractOptionsInput } from './input/ExtractOptionsInput';
import { CrawlOptionsInput } from './input/CrawlOptionsInput';
import { Collapsible } from './Collapsible';
import { Required } from './Required';
import { Optional } from './Optional';
import { paramsInputsStyle } from './shared';
import { Inner } from './Inner';

export const RunScrape = (props) => {
  const renderChildren = (params, onChange) => {
    return (
      <div style={paramsInputsStyle}>
        <Required style={paramsInputsStyle}>
          <PatternInput params={params} onChange={onChange} />
          <TemplateInput params={params} onChange={onChange} />
        </Required>

        <Optional style={paramsInputsStyle}>
          <Collapsible label="Start URLs" value={params.startUrls}>
            <StartUrlsInput noLabel params={params} onChange={onChange} />
          </Collapsible>
          <Collapsible label="Crawl Rules" value={params.priorit}>
            <PriorityInput params={params} onChange={onChange} />
          </Collapsible>

          <div style={{ display: 'flex', gap: 10 }}>
            <AIInput params={params} onChange={onChange} />
            <ProxyInput params={params} onChange={onChange} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <CrawlOptionsInput params={params} onChange={onChange} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <ExtractOptionsInput params={params} onChange={onChange} />
          </div>
        </Optional>
      </div>
    );
  };

  const examples = [
    {
      name: 'pokemon',
      params: {
        pattern: 'https://pokemondb.net/pokedex/*',
        template: 'pokemon name, number and basic stats.',
        maxVisits: 20,
        maxExtracts: 100,
      },
    },
  ];

  return (
    <div>
      <Inner
        endpoint="scrape"
        initialParams={props.params}
        examples={examples}
        renderChildren={renderChildren}
        {...props}
      />
    </div>
  );
};
